/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UrlaubsantragDto } from '../../models/urlaubsantrag-dto';

export interface CancelUrlaubsantrag$Json$Params {
  id: string;
}

export function cancelUrlaubsantrag$Json(http: HttpClient, rootUrl: string, params: CancelUrlaubsantrag$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<UrlaubsantragDto>> {
  const rb = new RequestBuilder(rootUrl, cancelUrlaubsantrag$Json.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UrlaubsantragDto>;
    })
  );
}

cancelUrlaubsantrag$Json.PATH = '/v1/urlaubsantraege/{id}/cancel';
